import { AgreementTermType, hasFixedTotal } from '@omnea-app/packages/universal/agreement/agreementTermTypes'
import { CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { Price } from '@omnea-app/packages/universal/price/price'
import { agreementTermToPrices } from './agreementTermToPrices'
import { type Amount, mapTermToPrices } from './mapTermToPrices'

// Typed as 'string' so both the backend and frontend satisfy the shape
type Term = {
  spend: ReadonlyArray<{ rate: number; frequency: string; fxRate: number; currencyCode: CurrencyCode }>
  totalAmount: Amount | null | undefined
}

type AgreementSpendInput = {
  mainTerm: Term & { type: AgreementTermType }
  terms: ReadonlyArray<Term>
  historicData?: { totalAmount: Amount | null | undefined } | null
}

type AgreementSpend = {
  activeSpend: Price[] | null
  totalSpend: Price[]
}

export const getAgreementSpend = (agreement: AgreementSpendInput): AgreementSpend => {
  const activeSpend = hasFixedTotal(agreement.mainTerm.type)
    ? mapTermToPrices(agreement.mainTerm.totalAmount)
    : agreementTermToPrices(agreement.mainTerm)

  const totalSpend =
    mapTermToPrices(agreement.historicData?.totalAmount) ??
    agreement.terms.flatMap((term, termIndex) => agreementTermToPrices(term, termIndex))

  return { activeSpend, totalSpend }
}
